module.exports = __webpack_public_path__ + "img/zj4362_center_002.800b34c3.png";